// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"cd7bac13","102":"93f41944","103":"5e5348c3","110":"eac2d8ab","141":"2a539452","266":"ad126520","312":"8452615b","453":"30900952","509":"d230d86f","641":"70c63e81","667":"125d3f7c","740":"54b1e69b","885":"3977cef0","921":"57b7433a"}[chunkId] + ".chunk.js";
};